import { ButtonHTMLAttributes, FunctionComponent, PropsWithChildren } from "react";
import * as Styled from "./styles";

interface IconButtonProps extends PropsWithChildren, ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  className?: string;
}

const IconButton: FunctionComponent<IconButtonProps> = ({
  name,
  className,
  onClick,
  children,
  ...props
}: IconButtonProps) => {
  return (
    <Styled.IconButtonDiv data-name={name} className={className} onClick={onClick} {...props}>
      {children}
    </Styled.IconButtonDiv>
  );
};

export default IconButton;
